import { useEffect, useState } from 'react';
import { LobbyTypeEnum } from '@sportspredict/shared';
import { TABS } from '@/constants';

interface UseLobbyActiveTabProps {
	tabParam: string | null;
	isMobile: boolean;
	isCrowdLockMode: boolean;
	lobbyType: string | undefined;
}

export function useLobbyActiveTab({
	tabParam,
	isMobile,
	isCrowdLockMode,
	lobbyType,
}: UseLobbyActiveTabProps) {
	const [activeTab, setActiveTab] = useState(() => {
		if (tabParam && Object.values(TABS).includes(tabParam)) return tabParam;
		return TABS.MARKETS;
	});

	const [swipeModeEnabled, setSwipeModeEnabled] = useState(isMobile);

	useEffect(() => {
		if (!isMobile) {
			setSwipeModeEnabled(isCrowdLockMode);
		}
	}, [isMobile, isCrowdLockMode]);

	useEffect(() => {
		if (lobbyType === LobbyTypeEnum.TotalWins) {
			setSwipeModeEnabled(false);
		}
	}, [lobbyType]);

	useEffect(() => {
		if (tabParam && Object.values(TABS).includes(tabParam)) {
			setActiveTab(tabParam);
		}
	}, [tabParam]);

	useEffect(() => {
		if (!isMobile && activeTab === TABS.HOME) {
			setActiveTab(TABS.MARKETS);
		}
	}, [isMobile, activeTab]);

	useEffect(() => {
		if (!lobbyType) return;

		if (lobbyType === LobbyTypeEnum.CrowdLock) {
			setActiveTab((prev) => (prev === TABS.MARKETS ? prev : TABS.MARKETS));
		}
	}, [lobbyType]);

	return { activeTab, setActiveTab, swipeModeEnabled, setSwipeModeEnabled };
}
